import { FormGroup } from '@angular/forms';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SharedPortalViewService } from 'src/app/components/user-dashboard/portal/view/shared-portal-view.service';
import { Observable, Subscription, lastValueFrom } from 'rxjs';
import { WebsiteModel } from 'src/app/components/user-dashboard/portal/portal.model';
import { Store } from '@ngrx/store';
import { selectWebsite } from '../../store/_features/website/website.selector';
import { ApiService } from '../../services/lsg.api.service';

import { PreviewTokenType } from 'src/app/models/preview';

@Component({
  selector: 'app-go-to-portal',
  templateUrl: './go-to-portal.component.html',
  styleUrls: ['./go-to-portal.component.css'],
})
export class GoToPortalComponent implements OnInit, OnDestroy {
  website: WebsiteModel;
  @Input() auth: PreviewTokenType = 'student';
  @Input() _domain: string = '';

  @Input() redirectPath: string = '';
  _redirectUrl: string = '';

  @Input() username: string = '';
  @Input() token: string = 'NHJjMzZhNVdBWmpVR1kyQXhJbGh1dz09';
  // @Input() tokenType: PreviewTokenType = 'student';

  _finalUrl: string;

  @Input() auto: boolean = true;
  @Input() courseId: string;
  @Input() lessonId: string;
  @Input() isPreview: boolean = true;

  subscriptions: Subscription[] = [];
  constructor(private store: Store, private api: ApiService) {}

  @Input('domain') set domainSetter(domain) {
    this._domain = domain;
    this.generateUrl();
  }

  @Input('redirectUrl') set redirectUrlSetter(redirectUrl) {
    this._redirectUrl = redirectUrl;
    this.generateUrl();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  async ngOnInit() {
    this.subscriptions.push(
      this.store.select(selectWebsite).subscribe((value) => {
        if (!!value) {
          this.website = value;
          this._domain = value.siteUrl;
          this.generateUrl();
        }
        if (!!this.auto) {
          //  this.subscriptions.push(
          //   // this.website$.subscribe((website) => {
          //   //   if (website) {
          //   //     this.username = website.websiteCredentials.username;
          //   //     this._domain = website.siteUrl;
          //   //     this.token = website.websiteCredentials.token;
          //   //   }
          //   // })
          //  )

          this.generateUrl();
        }
      })
    );
  }

  generateUrl() {
    const baseUrl = `http://${this._domain}/redme/?redme=`;

    console.log(baseUrl);
    let redirectUrl = this.encodeRedirect(this._redirectUrl);

    if (!!this.redirectPath.length) {
      if (
        this.redirectPath.startsWith('http://') ||
        this.redirectPath.startsWith('https://')
      ) {
        redirectUrl = this.encodeRedirect(this.redirectPath);
      } else {
        redirectUrl = this.encodeRedirect(
          `http://${this._domain}/${this.redirectPath}`
        );
      }
    }
    this._finalUrl = baseUrl + redirectUrl;
  }
  // onSubmit() {
  //   const myform = document.getElementById(
  //     `myCheckWebsiteForm${this.uid}`
  //   ) as HTMLFormElement;
  //   myform.submit();
  // }

  goToFinalURL() {
    if (this.isPreview && this.website) {
      // Use the subdomain name as the tenant slug (e.g., "rootsecho")
      // The Payload backend will resolve this slug to the internal Tenant ID.
      const tenantSlug =
        this.website.domains?.subdomain?.info?.name || this.website.id;

      this.subscriptions.push(
        this.api
          .createPreviewSession(this.courseId, this.lessonId, this.auth)
          .subscribe({
            next: (res: any) => {
              console.log('Preview Response Debug:', {
                res,
                token: res?.token,
                tokenType: res?.tokenType,
                isGuest: res?.tokenType === 'guest',
                outerCondition: res && (res.token || res.tokenType === 'guest'),
              });

              // Construct URL client-side
              // 1. Determine target path
              let targetPath = '';

              if (this.courseId) {
                // CASE A: Specific Course Context
                const targetCourseId = res.payloadCourseId || this.courseId;
                const lessonPath = this.lessonId
                  ? `/lesson/${this.lessonId}`
                  : '';
                targetPath = `/learn/${targetCourseId}${lessonPath}`;
              } else {
                // CASE B: Generic / Generic Context (use redirectPath or _redirectUrl)
                let rawRedirect = this.redirectPath || this._redirectUrl;

                if (rawRedirect) {
                  // Check if it's a full URL
                  if (
                    rawRedirect.startsWith('http://') ||
                    rawRedirect.startsWith('https://')
                  ) {
                    try {
                      const urlObj = new URL(rawRedirect);
                      // We only want the path and query params for the internal route
                      targetPath = urlObj.pathname + urlObj.search;
                      // If pathname is nothing, default to /
                      if (targetPath === '') targetPath = '/';
                    } catch (e) {
                      // If parsing fails, use as is (might be relative?) or fallback
                      console.warn('Failed to parse redirect URL', rawRedirect);
                      targetPath = '/';
                    }
                  } else {
                    // It's likely a relative path
                    targetPath = rawRedirect.startsWith('/')
                      ? rawRedirect
                      : `/${rawRedirect}`;
                  }
                } else {
                  // Fallback if absolutely nothing provided
                  targetPath = '/';
                }
              }

              // Ensure domain has protocol
              let domain = this._domain || this.website.siteUrl;
              if (!domain.startsWith('http')) {
                domain = `https://${domain}`;
              }

              // Remove trailing slash if present to avoid double slashes
              domain = domain.replace(/\/$/, '');

              if (res && res.tokenType === 'guest') {
                // GUEST FLOW
                // Navigate to preview route with 'guest' token to trigger session clearing
                const previewUrl = `${domain}/preview?token=guest&path=${encodeURIComponent(
                  targetPath
                )}`;
                window.open(previewUrl, '_blank');
              } else if (res && res.token) {
                // AUTHENTICATED FLOW
                const previewUrl = `${domain}/preview?token=${
                  res.token
                }&path=${encodeURIComponent(targetPath)}`;
                window.open(previewUrl, '_blank');
              } else if (res && res.previewUrl) {
                // FALLBACK
                window.open(res.previewUrl, '_blank');
              }
            },
            error: (err) => {
              console.error('Failed to create preview session', err);
              // Fallback to normal flow?
              const redirectUrl =
                this._finalUrl ||
                (this.redirectPath
                  ? `http://${this._domain}/${this.redirectPath}`
                  : '');
              if (redirectUrl) window.open(redirectUrl, '_blank');
            },
          })
      );
    } else {
      window.open(this._finalUrl, '_blank');
    }
  }

  encodeRedirect(url) {
    return encodeURIComponent(url);
  }
}
